import { Route } from '@angular/router';
import { PropertyDealsComponent } from './deals.component';
import {
  PipelinesResolver,
  ProjectDataResolver,
  ProjectsFieldDefsResolver,
} from 'app/modules/projects/projects.resolvers';
import { SavedViewsResolver } from 'app/core';
import { NearbyPropertyResolver } from './deals.resolvers';

export const nearbyRoutes: Route[] = [
  {
    path: '',
    component: PropertyDealsComponent,
    resolve: {
      options: ProjectDataResolver,
      fieldDefs: ProjectsFieldDefsResolver,
      savedViews: SavedViewsResolver,
      property: NearbyPropertyResolver,
      pipelines: PipelinesResolver,
    },
    children: [],
  },
];
